import(/* webpackMode: "eager" */ "/var/www/vhosts/dailyneedsproducts.com/httpdocs/src/app/shipping-policy/page.tsx");
